import {ApiKeyResponse, CreditDetailsResponse} from "@/types/service-response";

export default class ApiKey {
  private constructor (
    readonly id: string,
    readonly token: string,
    readonly createdAt: string,
  ) {}



    static createFromResponse (responseData: ApiKeyResponse): ApiKey {
      return new ApiKey(
          responseData.id,
          responseData.token,
          responseData.createdAt,
      )
    }

  static createFromResponseList (responseData: ApiKeyResponse[]): ApiKey[]{
    return  responseData.map((item: ApiKeyResponse)=>{
          return new ApiKey(
              item.id,
              item.token,
              item.createdAt,

          )
        }
    )
  }
}